import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play--sprite",
  "use": "play--sprite-usage",
  "viewBox": "0 0 56 56",
  "content": "<symbol viewBox=\"0 0 56 56\" id=\"play--sprite\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56ZM20.5 40.9904L43 28L20.5 15.0096L20.5 40.9904Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol